import script from "./searchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./searchInput.vue?vue&type=script&setup=true&lang=js"

import "./searchInput.vue?vue&type=style&index=0&id=4624cd29&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4624cd29"]])

export default __exports__